export default __webpack_public_path__ + "static/media/tenant-bild.3e724af0.svg";